module.exports = __webpack_public_path__ + "static/media/bedding-dark-gray.e0de0a22.svg";